import React from 'react';
import IntegrationLoginButton from './IntegrationLoginButton';
import getExternalServiceName from '../../utils/text/getExternalServiceName';

interface IntegrationLoginButtonsProps {
  email: string;
  provisionId?: string;
  provisionSecret?: string;
  register?: boolean;
  ssoPlatforms: string[];
}

const IntegrationLoginButtons = ({
  email,
  provisionId,
  provisionSecret,
  register = false,
  ssoPlatforms,
}: IntegrationLoginButtonsProps) => (
  <>
    {ssoPlatforms
      .toSorted((a, b) => {
        if (a === 'google') return 1;
        if (b === 'google') return -1;
        return 0;
      })
      .map((platform) => (
        <IntegrationLoginButton
          key={platform}
          instruction={platform === 'google' ? `using @${email} email` : ''}
          provisionId={provisionId}
          provisionSecret={provisionSecret}
          platform={platform}
          platformName={getExternalServiceName(platform)}
          register={register}
        />
      ))}
  </>
);

export default IntegrationLoginButtons;
